import { RootDispatch } from "redux/rootReducer";
import { load, loadFail, loadSuccess } from "./privateEquityCapitalCallActions";
import * as request from "utility/request";
import { PrivateEquityCapitalCall } from "types/PrivateEquityCapitalCall";

const apiUrl = process.env.REACT_APP_API_URL;

export const loadPrivateEquityCapitalCall = (reportControlId: string, reportDate: string) => {
  return async (dispatch: RootDispatch) => {
    dispatch(load("all"));

    try {
      const res = await request.getResponseJson<PrivateEquityCapitalCall[]>(
        `${apiUrl}/api/privateEquityCapitalCalls?reportControlId=${reportControlId}&reportDate=${reportDate}`
      );
      dispatch(loadSuccess("all", res));
    } catch (error) {
      return request.handleFetchError(dispatch, error, loadFail("all", error));
    }
  };
};
